import { render, staticRenderFns } from "./AppDreLancamento.vue?vue&type=template&id=23f02efd&"
import script from "./AppDreLancamento.vue?vue&type=script&lang=js&"
export * from "./AppDreLancamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports